// frontend common module
// exports are idempotent, the entry owns dom ready, the mutation observer
// and the resize handler, so nothing here wires up globals on import

const modifyTag = {
	init: function () {
		document.querySelectorAll( '.bpf-content' ).forEach(
			function ( holder ) {
				// init only once per holder, entry calls init again for ajax loaded posts
				if ( holder.dataset.bpfTag ) {
					return;
				}

				holder.dataset.bpfTag = 'done';

				// call replace permalink method first, anchors can't be nested
				modifyTag.replacePermalink( holder );
				// call modify tag method
				modifyTag.modifyTag( holder );
			}
		);
	},

	replacePermalink: function ( holder ) {
		const permalink = holder.closest( 'a' );

		if ( ! permalink ) {
			return false;
		}

		// replace a with div, keep child nodes as they are
		const replacement = document.createElement( 'div' );

		replacement.className = 'bpf-default-permalink--replaced';

		while ( permalink.firstChild ) {
			replacement.appendChild( permalink.firstChild );
		}

		permalink.replaceWith( replacement );

		return true;
	},

	modifyTag: function ( holder ) {
		// only link and quote templates have var placeholders
		const isPlaceholderFormat = holder.classList.contains( 'bpf-content--format-link' ) ||
			holder.classList.contains( 'bpf-content--format-quote' );

		if ( ! isPlaceholderFormat ) {
			return;
		}

		holder.querySelectorAll( 'var[data-href]' ).forEach(
			function ( placeholder ) {
				// call to anchor method
				modifyTag.toAnchor( placeholder );
			}
		);
	},

	toAnchor: function ( placeholder ) {
		const anchor = document.createElement( 'a' );

		// copy all attributes and remove data- prefix template added to keep markup valid
		Array.prototype.forEach.call(
			placeholder.attributes,
			function ( attribute ) {
				const name = 0 === attribute.name.indexOf( 'data-' ) ? attribute.name.slice( 5 ) : attribute.name;

				anchor.setAttribute( name, attribute.value );
			}
		);

		while ( placeholder.firstChild ) {
			anchor.appendChild( placeholder.firstChild );
		}

		placeholder.replaceWith( anchor );
	}
};

const resizeIFrame = {
	init: function () {
		// video oembeds scale by ratio, audio players keep the fixed height their provider sent
		document.querySelectorAll( '.bpf-content--format-video iframe' ).forEach(
			function ( holder ) {
				// call resize method
				resizeIFrame.resize( holder );
			}
		);
	},

	// oembed providers also send '100%' or 'auto', which parseFloat reads as a number,
	// Number() keeps only plain pixel values, everything else comes back as 0
	toPixels: function ( value ) {
		const size = Number( value );

		return isFinite( size ) && 0 < size ? size : 0;
	},

	resize: function ( holder ) {
		const width  = resizeIFrame.toPixels( holder.getAttribute( 'width' ) ),
			height = resizeIFrame.toPixels( holder.getAttribute( 'height' ) );

		// provider left the sizes out or sent them in percentages, so there is no ratio to scale by
		if ( ! width || ! height ) {
			return;
		}

		holder.style.height = ( holder.clientWidth * height / width ) + 'px';
	}
};

const addArticleClass = {
	// link and quote featured content carries the post title itself, so the theme one is hidden
	init: function () {
		document.querySelectorAll( '.bpf-content--format-link, .bpf-content--format-quote' ).forEach(
			function ( holder ) {
				addArticleClass.addClass( holder );
			}
		);
	},

	addClass: function ( holder ) {
		// walk up to closest ancestor holding the title of this post, so other posts are left alone
		let node = holder.parentElement;

		while ( node && node !== document.documentElement ) {
			if ( node.querySelector( '.entry-title, .wp-block-post-title' ) ) {
				node.classList.add( 'bpf-hide-default-title' );

				return;
			}

			node = node.parentElement;
		}
	}
};

// set up any holder that has not been handled yet
export function init() {
	modifyTag.init();
	resizeIFrame.init();
	addArticleClass.init();
}

// re-measure oembed iframes, called by the resize handler in the entry
export function resizeIFrames() {
	resizeIFrame.init();
}
